"use client";
import React,{Children, useState} from 'react';
import LayoutGallery from '../Gallery/LayoutGallery';
const initialState={
    activePanel:"VideosC",
    captureImage:[],
    modalData:{
      isOpen:false,
      type:null,
      folderUpdate:false,
      galeryUpdate:false,
      galleryStatus:null,
      status:null,
      isPlayAll:false,
    },   

    currentFolderData:null,
    currentGalleryData:null,
    currentTemplateId:null,
    currentFontFamilyVideoTitle:'Great Vibes',
    currentFontFamilyVideoSubTitle:'Poppins',
  currentTitleColor: null,
    currentFontFamilyLogoTxt: null,
  currentLogoColor: null,
  currentLogoFontSize:null,
    currentSubTitleColor:null,
     currentTitleFontSize:null,
    currentSubTitleFontSize:null,
    currentFolderName:null,
    currentFolderId:null,
    currentDBFolderId:null,
    currentGalleryName:null,
    currentGalleryVideoTitle:null,
    currentGalleryVideoSubTitle:null,
    currentGalleryId:null,
    currentDBGalleryId:null,
    currentVideoId:null,
    currentDBVideoId:null,
    currentVideoName:null,
    
  videoArr: [],
    photoArr:[],
    currentChapterArr:[],
    currentVideoUrl:null,
    currentVideoCuePoint:null,
    backgroundMedia:{
      videoUrl:null,
      musicUrl:null,
      imgUrl:null,
    },
    
    layoutArr:[],
    allFolderData:[],
    finalClientData:[],
    temp:"ram",
    
}
export const Context = React.createContext();

const AppContext = (props) => 
{
    const [state,setState]=useState(initialState);
    return (
      <Context.Provider  value={{value:[state,setState]}}>{props.children}</Context.Provider>
    )
}

export default AppContext;
